const smsSend = () => import ('@/views/sms/Send')
const smsCharge = () => import ('@/views/sms/Index')
// const refueingDetail = () => import ('@/views/refueing/Detail')
export default [
    { name:'smsCharge', path: '/sms/charge', component: smsCharge},
    { name:'smsSend', path: '/sms/send', component: smsSend},
    // { name:'refueingDetail', path: '/refueing/detail', component: refueingDetail}
]